module.exports = __webpack_public_path__ + "static/media/settings.f92e878f.png";